export default __webpack_public_path__ + "static/chaga-2f2dfe3a5757207b0dae230ba190959b.webp";